{
    "subscriptions": "Keine Abonnements verfügbar.",
    "cost_centers": "Keine Kostenstellen verfügbar.",
    "employees": "Keine Mitarbeiter:innen verfügbar",
    "vendors": "Keine Lieferanten verfügbar.",
    "budgets": "Keine Budgets verfügbar.",
    "approvals": "Keine Freigaben verfügbar.",
    "expense_data": "Keine Anträge verfügbar.",
    "limits": "Keine Limits verfügbar.",
    "company_data": "Es wurden noch keine Firmendaten hinzugefügt.",
    "not_available": "Nicht verfügbar",
    "no_data": "Keine Daten",
    "no_bank_accounts": "Es wurden noch keine Bankverbindungen hinzugefügt.",
    "no_expense_accounts": "Es wurden noch keine Sachkonten hinzugefügt.",
    "no_expense_accounts_yet": "Keine Sachkonten verfügbar",
    "no_cost_center_2": "Es wurden noch keine Kostenträger hinzugefügt.",
    "no_cost_center_2_yet": "Keine Kostenträger verfügbar.",
    "no_payment_data": "Es wurde noch kein Zahlungsabonnement hinzugefügt.",
    "select_option_no_value": "-",
    "employee": {
        "superior": "Kein:e Vorgesetzte:r ausgewählt"
    },
    "banking": {
        "no_banks_found": "Keine Banken gefunden, die dem Suchkriterium entsprechen.",
        "bank_connection": "Sie sollten ein verbundenes Bankkonto haben, um eine Überweisung durchführen zu können."
    },
    "request": {
        "expense_account": "Kein Sachkonto ausgewählt",
        "cost_center_2": "Kein Kostenträger ausgewählt",
        "cost_center_1": "Keine Kostenstelle ausgewählt"
    },
    "transactions": {
        "possible_expenses": "Keine passenden Anträge gefunden.",
        "matched_expenses": "Keine Anträge ge-matched."
    },
    "cards": {
        "no_cards": "Keine Karten verfügbar.",
        "no_transactions": "Keine Transaktionen verfügbar.",
        "no_phone_number": "Diese Karte hat keine Mobiltelefonnummer gesetzt."
    },
    "inbox_invoice": {
        "no_docs_needed_expenses": "Momentan gibt es keine Anträge, die Dokumente benötigen. Sie können dennoch eine neue Rechnungsfreigabe für diese Rechnung mit dem Button unten erstellen.",
        "no_invoices_in_inbox": "Momentan gibt es keine Rechnungen in der Inbox."
    },
    "no_tax": "Es wurde noch kein Mehrwertsteuer hinzugefügt.",
    "no_tax_yet": "Keine Mehrwertsteuer verfügbar",
    "no_team": "Es wurde noch keine Abteilung hinzugefügt.",
    "no_team_yet": "Keine Abteilung verfügbar",
    "no_forecast_rules": "Keine Prognoseregel verfügbar.",
    "transaction_category": "Un-kategorisiert",
    "no_imports_yet": "Noch keine Importierungen vorhanden.",
    "no_export_history": "Noch keine Exporte vorhanden."
}
